'use client'

import { CheckIcon, LinkIcon } from 'lucide-react'
import React, { useState } from 'react'

import { cn } from '../../ui/cn'

interface CopyLinkButtonProps {
  anchor: string
}

export const CopyLinkButton = ({ anchor }: CopyLinkButtonProps): React.ReactElement => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async (): Promise<void> => {
    const url = `${window.location.origin}${window.location.pathname}#${anchor}`
    try {
      await navigator.clipboard.writeText(url)
    } catch {
      return
    }
    setCopied(true)
    window.setTimeout(() => setCopied(false), 2000)
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      aria-live="polite"
      className={cn(
        'snplay:mt-4 snplay:inline-flex snplay:cursor-pointer snplay:items-center',
        'snplay:gap-1.5 snplay:text-sm snplay:font-medium',
        'snplay:text-ui-secondary snplay:transition snplay:hover:text-primaryDark',
      )}
    >
      {copied ? (
        <CheckIcon aria-hidden="true" className="snplay:size-4" />
      ) : (
        <LinkIcon aria-hidden="true" className="snplay:size-4" />
      )}
      {copied ? 'Copied' : 'Copy Link'}
    </button>
  )
}
